module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-4-Australia-Landing-Page-w540.fc86d59f.jpg";